import { EyeFilled } from "@ant-design/icons";
import { ConfigProvider, Flex, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { createUseStyles } from 'react-jss';
import { useSelector } from "react-redux";




// const ATTENDANCE_SETTING_MENU = [
//     getItem(
//         "workin_location",
//         "Working Location",
//         "working",
//         <CopyOutlined style={{ color: "gray" }} />
//     ),
//     getItem(
//         "holiday",
//         "Holiday Calendar",
//         "holiday",
//         <CalendarOutlined style={{ color: "gray" }} />
//     ),
//     getItem(
//         "leave_type",
//         "Leave Type",
//         "leave",
//         <CopyOutlined style={{ color: "gray" }} />
//     ),
//     getItem(
//         "shift",
//         "Shifts",
//         "shifts",
//         <CopyOutlined style={{ color: "gray" }} />
//     ),
//     getItem(
//         "workflow",
//         "Work Flow",
//         "workFlow",
//         <CopyOutlined style={{ color: "gray" }} />
//     ),
// ];


const AttendanceTabMenu = ({ selectedKeys, menuList = [], className = "", onChange = () => { }, handleMenuChange = () => { }, isCard = false, defalut = null, backgroundColor = '#2151b6', color = 'white' }) => {

    const onMenuClick = (e) => {
        const key = e;
        console.log("key", e);
        onChange(key);
        // storage.sessionStorage.setItem("config.menu", key);
    };
    console.log("AttendanceTabMenu selectedKeys", selectedKeys);
    const { roles } = useSelector((state) => state.company);
    function getItem(rules, label, key, icons) {
        let list = [...roles]
        if (!list.includes(rules)) {
            return {}
        }
        return {
            key,
            icons,
            label,
        };


    }
    const { t, i18n } = useTranslation();
    const MENU = [
        getItem(
            "ACCESS_CONFIGURATION|ATTENDANCE_SETTING|WORK_IN_LOCATION",
            t('workin_location.header'),
            "working",

        ),
        getItem(
            "ACCESS_CONFIGURATION|ATTENDANCE_SETTING|HOLIDAY_CALENDAR",
            t('holiday.header'),
            "holiday",

        ),
        getItem(
            "ACCESS_CONFIGURATION|ATTENDANCE_SETTING|LEAVE_TYPE",
            t('leave_type.header'),
            "leave",

        ),
        getItem(
            "ACCESS_CONFIGURATION|ATTENDANCE_SETTING|SHIFT",
            t('shift.header'),
            "shifts",

        ),
        getItem(
            "ACCESS_CONFIGURATION|ATTENDANCE_SETTING|WORK_FLOW",
            t('workflow.header'),
            "workflow",

        ),
        getItem(
            "ACCESS_CONFIGURATION|ATTENDANCE_SETTING|BE_PERFORM_CONDITION",
            t('besmart_Perfrom.header'),
            "bePerform",
        ),

        getItem(
            "ACCESS_CONFIGURATION|ATTENDANCE_SETTING|CONFIG_BE_SMART",
            t('configBesmart.config_Besmart'),
            "configBesmart",
        ),
    ];
    // useEffect(() => {
    //     const key = storage.sessionStorage.getItem("config.menu");
    //     console.log("use eff");
    //     if (ATTENDANCE_PAGE_LIST.includes(key)) {
    //         onChange(key);
    //     }else{

    //     }
    // }, []);

    // console.log("selectedKeys", selectedKeys);

    const useStyles2 = createUseStyles({
        tab: {
            '& .ant-tabs-tab': {
                textAlign: 'center',
                padding: '12px 16px',
                borderRadius: '10rem',
                // margin: '5px',
                fontWeight: 'bold', // Applied to all .ant-tabs .ant-tabs-tab
                background: 'transparent', // Applied to all .ant-tabs .ant-tabs-tab
            },
            '& .ant-tabs-tab.ant-tabs-tab-active': {
                fontWeight: 'bold',
                color: 'white !important',
                background: `${backgroundColor} !important`,
                margin: '5px',
            },
            '& .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left::before': {
                opacity: '0 !important',
            },
            '& .ant-tabs-nav': {
                margin: '0',
            },
            '& .ant-tabs-nav::before': {
                display: 'none !important',
            },
        },
    });

    const classes = useStyles2();

    return (

        <ConfigProvider theme={{
            components: {
                Tabs: {
                    itemHoverColor: "var(--tab-color)",
                    itemActiveColor: "var(--tab-color)"
                },
            },
        }}>
            <Tabs activeKey={selectedKeys} onChange={onMenuClick} items={MENU?.filter(o => o.key != null)?.map((entity) => {
                return {
                    ...entity,
                    label: <Flex gap={5} style={{
                    }}>{entity.icons} {entity.label}
                    </Flex>
                };
            })}>
            </Tabs>
        </ConfigProvider>
    );
};

export default AttendanceTabMenu;
